import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=2a3f37b6"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a3f37b6')) {
      api.createRecord('2a3f37b6', component.options)
    } else {
      api.reload('2a3f37b6', component.options)
    }
    module.hot.accept("./Wrapper.vue?vue&type=template&id=2a3f37b6", function () {
      api.rerender('2a3f37b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/availableSpaces/Wrapper.vue"
export default component.exports